<template>
  <div class="image-list">
    <el-image
      v-for="(item,index) in listNew"
      :key="index"
      :src="item"
      fit="contain "
      :preview-src-list="listNew">
    </el-image>
  </div>
</template>
<script>
export default {
  name: 'ImageList',
  props: {
    list: { type: [Array, String] },
    listType: { type: Number, default: 2 }
  },
  computed: {
    listNew({ list, listType }) {
      console.log('111111111111111111', list, listType)
      return listType === 1 ? list : (listType === 2 ? list.map(i => i.url) : list.split(','))
    }
  }
}
</script>
<style lang="stylus" scoped>
.image-list {
  /deep/ .el-image {
    width: var(--image-width, 64px);
    height: var(--image-height, 64px);
    margin: 0 3px 3px 0;
    border: 1px solid #eee;
    box-sizing: border-box;
  }
}
</style>
